import _defineProperty from "/workdir/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import classNames from 'classnames';
import { Button } from '@hub/button';
import { Box } from '@hub/box';
import { Link } from '@hub/link';
import Icon from "@scentregroup/ui/components/icon";
import TimedDisplay from "@scentregroup/ui/components/timed-display";
import useMobileBreakpoint from '@scentregroup/shared/helpers/use-mobile-breakpoint';
import { kebabCase, lowerCase } from 'lodash';
import Spinner from '../spinner';
import style from './index.module.scss';
import { logSeeAllProducts } from './analytics';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const SPINNER_DELAY = 250;
const MAX_PRODUCT_ITEMS = 5;
const MAX_PRODUCT_ITEMS_MOBILE = 4;

const ProductResults = ({
  hits,
  showFixedQuery
}) => {
  const isMobile = useMobileBreakpoint();
  const query = new URLSearchParams({
    q: showFixedQuery !== null && showFixedQuery !== void 0 ? showFixedQuery : ''
  }).toString();
  return /*#__PURE__*/_jsxs(React.Fragment, {
    children: [/*#__PURE__*/_jsx("nav", {
      className: classNames(style.resultsLinks, style.products),
      children: hits.slice(0, isMobile ? MAX_PRODUCT_ITEMS_MOBILE : MAX_PRODUCT_ITEMS)
    }), /*#__PURE__*/_jsx(Box, {
      sx: {
        textAlign: 'center',
        marginTop: 'spacing-lg'
      },
      children: /*#__PURE__*/_jsx(Button, {
        as: props => /*#__PURE__*/_jsx(Link, _objectSpread({
          href: "/shop/products/?".concat(query)
        }, props)),
        colorScheme: "licorice",
        size: "lg",
        sx: {
          width: ['100%', 'size-20'],
          textDecoration: 'none !important'
        },
        onClick: logSeeAllProducts,
        children: "SEE ALL PRODUCTS"
      })
    })]
  });
};

const WestfieldProductResults = ({
  hits
}) => {
  const isMobile = useMobileBreakpoint();
  return /*#__PURE__*/_jsx("nav", {
    className: classNames(style.resultsLinks, style.products),
    children: hits.slice(0, isMobile ? MAX_PRODUCT_ITEMS_MOBILE : MAX_PRODUCT_ITEMS)
  });
};

const Contents = ({
  isLoading,
  showNoResults,
  results,
  showFixedQuery
}) => {
  if (isLoading) {
    return /*#__PURE__*/_jsxs(TimedDisplay, {
      timing: SPINNER_DELAY,
      children: [null, /*#__PURE__*/_jsx(Spinner, {
        className: style.Spinner
      })]
    });
  } else if (showNoResults) {
    return /*#__PURE__*/_jsxs("div", {
      className: style.noResults,
      children: [/*#__PURE__*/_jsx(Icon, {
        className: style.alertIcon,
        type: "alert",
        size: "medium"
      }), /*#__PURE__*/_jsx("p", {
        children: "No results found."
      }), /*#__PURE__*/_jsx("p", {
        children: "Try a new search to find more results."
      })]
    });
  } else {
    const sections = results.map(({
      heading,
      hits,
      queryId,
      indexName
    }, index) => {
      let section = /*#__PURE__*/_jsx("nav", {
        className: style.resultsLinks,
        children: hits
      });

      if (heading === 'Products') {
        section = /*#__PURE__*/_jsx(ProductResults, {
          hits: hits,
          showFixedQuery: showFixedQuery
        });
      } else if (heading === 'Westfield Gift Cards') {
        section = /*#__PURE__*/_jsx(WestfieldProductResults, {
          hits: hits
        });
      }

      return /*#__PURE__*/_jsxs("section", {
        className: style.category,
        "data-test-id": "search-contents-".concat(kebabCase(lowerCase(heading))),
        "data-insights-index": indexName,
        "data-insights-query-id": queryId,
        children: [/*#__PURE__*/_jsx("h2", {
          className: style.heading,
          children: heading
        }), section]
      }, index);
    });
    return /*#__PURE__*/_jsx(_Fragment, {
      children: sections
    });
  }
};

const SearchResults = props => /*#__PURE__*/_jsxs("div", {
  className: style.results,
  children: [props.showFixedQuery !== undefined && /*#__PURE__*/_jsxs("h1", {
    className: style.mainHeading,
    children: ["Results for \"", props.showFixedQuery, "\""]
  }), /*#__PURE__*/_jsx(Contents, _objectSpread({}, props))]
});

export default SearchResults;